export default __webpack_public_path__ + "static/media/appleStore.bf879409.png";